// extracted by mini-css-extract-plugin
export default {"verdict":"wTVJM5irxycgS3JgzHS_","glyph":"Dh6b64j8DJji60NjBkhP","glyph-dot":"Ei8OiqREjN_csbVHZiPq"};